import { render, staticRenderFns } from "./TemplateManager.vue?vue&type=template&id=012cc634&scoped=true&"
import script from "./TemplateManager.vue?vue&type=script&lang=js&"
export * from "./TemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManager.vue?vue&type=style&index=0&id=012cc634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cc634",
  null
  
)

export default component.exports